import { useParams } from "react-router-dom";

export default function Stub() {
  let params = useParams();
  return <div className="bg-black/50">{params.id}</div>;
}
